export enum ReportType {
  general = 'Campaign Report',
  quarter = 'Quarter Report',
  month = 'Month Report',
}
